import React, { useEffect, useReducer } from 'react';
import {
  FacetFilteringContextProps,
  IFacetFilteringContext,
} from '@sls-react/contexts/facetFiltering/intf';
import { reducer } from '@sls-react/contexts/facetFiltering/reducer';
import flattenFilterState from '@sls-react/contexts/facetFiltering/flattenFilterState';

export const FacetFilteringContext = React.createContext<
  IFacetFilteringContext
>({
  state: {
    facets: [],
    filterState: {},
    type: 'browse',
  },
  dispatch: action => {},
});

export const FacetFilteringProvider: React.FC<FacetFilteringContextProps> = ({
  children,
  facets,
  filterState,
  inModal,
  lander,
  paging,
  similarToItem,
  sorts,
  type,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    facets,
    filterState: flattenFilterState(filterState),
    inModal,
    lander,
    paging,
    similarToItem,
    sorts,
    type,
  });

  useEffect(() => {
    dispatch({
      type: 'EXTERNAL_DATA_CHANGE',
      payload: {
        facets,
        filterState: flattenFilterState(filterState),
        inModal,
        lander,
        paging,
        similarToItem,
        sorts,
        type,
      },
    });
  }, [
    dispatch,
    lander,
    inModal,
    facets,
    filterState,
    paging,
    type,
    similarToItem,
    sorts,
  ]);

  return (
    <FacetFilteringContext.Provider value={{ state, dispatch }}>
      {children}
    </FacetFilteringContext.Provider>
  );
};
